import { Box } from '@mui/material';
import { WidgetOption } from './WidgetSelector';
import { NumericInput } from '../NumericInputField';

type ProbabilityDist = Models.SetsPlayground.ProbabilitySetDistribution;

interface Props {
    value: ProbabilityDist;
    onChange: (next: ProbabilityDist) => void;
    disabled?: boolean;
}

const ProbabilityDistributionWidgetComponent = ({ value, onChange, disabled }: Props): JSX.Element => {
    const handlePart = (newValue: number | undefined): void => {
        onChange({ ...value, part: newValue ?? 0 });
    };

    const handleOffset = (newValue: number | undefined): void => {
        onChange({ ...value, offset: newValue });
    };

    const handleLimit = (newValue: number | undefined): void => {
        onChange({ ...value, limit: newValue });
    };

    return (

        <Box display="grid" gap={2} gridTemplateColumns={{ xs: '1fr', sm: 'repeat(3, 1fr)' }}>
            <NumericInput
                allowDecimals
                required
                disabled={disabled}
                label="Probability (0–1)"
                max={1}
                min={0}
                value={value.part}
                onChange={handlePart}
            />
            <NumericInput
                disabled={disabled}
                label="Offset"
                min={0}
                placeholder="Value is zero indexed"
                step={1}
                value={value.offset}
                onChange={handleOffset}
            />
            <NumericInput
                disabled={disabled}
                label="Limit"
                min={0}
                step={1}
                value={value.limit}
                onChange={handleLimit}
            />
        </Box>
    );
};

export const ProbabilityDistributionWidget: WidgetOption<ProbabilityDist> = {
    label: 'Probability Distribution',
    value: 'probability',
    helperText: 'Set the probability distribution for the set from a scale of 0 to 1.',
    component: ProbabilityDistributionWidgetComponent,
    getDefaultValue: () => ({
        type: 'probability',
        part: 0.5,
    }),
};
